import { render } from "./NotificationLogs.vue?vue&type=template&id=7b8d5eeb"
import script from "./NotificationLogs.vue?vue&type=script&lang=js"
export * from "./NotificationLogs.vue?vue&type=script&lang=js"

import "./NotificationLogs.vue?vue&type=style&index=0&id=7b8d5eeb&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__